import clsx from "clsx";
import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./style/StarRating.module.css";

const StarRating = (props) => {
  const { numRating, className, active, onChange } = props;
  const [hoverStar, setHoverStar] = useState(-1);

  const fullStart = <i className="bi bi-star-fill"></i>;
  const haftStart = <i className="bi bi-star-half"></i>;
  const emptyStart = (
    <i className={clsx("bi bi-star-fill", styles.emptyStar)}></i>
  );

  let rating = numRating;
  let floor = Math.floor(numRating);

  if (rating > floor + 0.5) {
    rating = floor + 1;
  } else if (rating > floor) {
    rating = floor + 0.5;
  } else {
    rating = floor;
  }

  if (active) {
    return (
      <div className={clsx(styles.container, className)}>
        {[1, 2, 3, 4, 5].map((num) => {
          let star =
            numRating >= num
              ? fullStart
              : numRating <= num - 1
              ? emptyStart
              : haftStart;

          if (hoverStar !== -1) {
            star =
              hoverStar >= num
                ? fullStart
                : hoverStar <= num - 1
                ? emptyStart
                : haftStart;
          }
          return (
            <div
              key={num}
              onMouseEnter={() => setHoverStar(num)}
              onMouseLeave={() => setHoverStar(-1)}
              onClick={() => onChange(num)}
              className={styles.start}
            >
              {star}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className={clsx(styles.container, className)}>
      {[1, 2, 3, 4, 5].map((num) => {
        const star =
          rating >= num
            ? fullStart
            : rating <= num - 1
            ? emptyStart
            : haftStart;
        return <div key={num}>{star}</div>;
      })}
    </div>
  );
};

/* required: display name */
StarRating.displayName = "StarRating";

/* required: props types */
StarRating.propTypes = {
  numRating: PropTypes.number,
  className: PropTypes.string,
  active: PropTypes.bool,
};

/* required: default props */
StarRating.defaultProps = { numRating: 0, className: "", active: false };

export { StarRating };
